import React from 'react';
import { IText } from 'fabric';
import { Trash2 } from 'lucide-react';
import { useEditorCanvas } from '../../../canvas/hooks/use-editor-canvas';
import { ToolbarSeparator } from '../../../shared/ui/toolbar-separator';
import { ToolBtn } from '../../../shared/ui/tool-btn';
import { AnimationSelector } from '../../../animations/components/animation-selector';
import { FontControls } from './font-controls';
import { FormatControls } from './format-controls';
import { AlignControls } from './align-controls';
import { ColorControl } from './color-control';

export const TextSettings: React.FC = () => {
  const { canvas, selectedObject, deleteSelected } = useEditorCanvas();
  const textObject = selectedObject as IText;

  if (!canvas || !textObject) return null;

  return (
    <>
      <FontControls textObject={textObject} canvas={canvas} />
      <ToolbarSeparator />
      <FormatControls textObject={textObject} canvas={canvas} />
      <ToolbarSeparator />
      <AlignControls textObject={textObject} canvas={canvas} />
      <ToolbarSeparator />
      <ColorControl textObject={textObject} canvas={canvas} />
      <ToolbarSeparator />
      <AnimationSelector />
      <ToolbarSeparator />
      <ToolBtn onClick={deleteSelected} variant='danger' title='Eliminar'>
        <Trash2 size={15} />
      </ToolBtn>
    </>
  );
};
